export default {
    APPLIED: function (name) { return "Coupon applied: " + name; },
    ERROR_EXISTING_DISCOUNTS: 'Could not apply coupon to order with existing discounts.',
    // assumes amount is preformatted
    ERROR_MINIMUM_SUBTOTAL: function (amount) { return "Coupon available but minimum order amount of $" + amount + " is required."; },
    ERROR_MINIMUM_AFTER_SUBTOTAL: function (amount) { return "Coupon available but order amount must be at least $" + amount + " after the coupon is applied."; },
    NO_ITEMS: 'This coupon is valid, but there are no items available.',
};



//////////////////
// WEBPACK FOOTER
// ./src/common/messages/coupon.ts
// module id = null
// module chunks = 